import cn from 'classnames';

import Image from '@/components/Image';
import { type TWhatsIncluded } from '@/infra/types/voyageInfo/sailing';

import styles from './WhatsIncludedItem.module.scss';

type TWhatsIncludedItemProps = {
  feature: TWhatsIncluded;
  fullWidth?: boolean;
  inline?: boolean;
};

export const WhatsIncludedItem = ({ feature, fullWidth, inline }: TWhatsIncludedItemProps) => {
  return (
    <div
      className={cn(
        styles.WhatsIncludedRow,
        inline && styles.WhatsIncludedRowInline,
        fullWidth && styles.WhatsIncludedRowFullWidth,
      )}
    >
      <div className={styles.IncludeImage}>
        {' '}
        <Image alt="" className={styles.image} src={feature?.image?.src} />
      </div>
      <div className={styles.IncludeTextContent}>
        <p className={styles.featureName}>{feature?.text}</p>
        <p className={styles.featureDescription}>{feature?.description}</p>
        <div className={styles.IncludedBottomBorder} />
      </div>
    </div>
  );
};
